import axios from 'axios';
import {
    getRequest,
    getSuccess,
    getFailed,
    getError,
    stuffDone,
} from './studentSlice';

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const getAllStudents = (id) => async (dispatch) => {
    dispatch(getRequest());

    try {
        const result = await axios.get(`${process.env.REACT_APP_BASE_URL}/Students/${id}`);
        if (result.data.message) {
            dispatch(getFailed(result.data.message));
        } else {
            dispatch(getSuccess(result.data));
        }
    } catch (error) {
        dispatch(getError(error));
    }
}

export const updateStudentFields = (classId, attendanceData, endpoint) => async (dispatch) => {
    dispatch(getRequest());
    try {
        const payload = {
            attendanceData: attendanceData.map(item => ({
                studentId: item.studentId,
                subName: item.subName,
                status: item.status,
                date: item.date

            }))
        };

        const result = await axios.put(
            `${BASE_URL}/${endpoint}/${classId}`,
            payload,
            { headers: { 'Content-Type': 'application/json' } }
        );

        const message = result.data?.message || "Attendance marked successfully";
        dispatch(stuffDone(message));
        return { success: true, message };
    } catch (error) {
        const errorMessage = error.response?.data?.message || error.message || "Failed to submit attendance";
        console.error("Attendance Error:", error.response?.data || error);
        dispatch(getError(errorMessage));
        return { success: false, error: errorMessage };
    }
};
export const updateStudentField = (classID, marksData, endpoint) => async (dispatch) => {
    dispatch(getRequest());
    try {
        const payload = {
            marksData: marksData.map(student => ({
                studentId: student.studentId,
                subName: student.subName,
                marksObtained: student.marksObtained,
                date: student.date || new Date().toISOString()
            }))
        };

        const result = await axios.put(
            `${BASE_URL}/${endpoint}/${classID}`,
            payload,
            { headers: { 'Content-Type': 'application/json' } }
        );

        dispatch(stuffDone(result.data));
        return { success: true, message: result.data?.message || "Marks updated successfully" };
    } catch (error) {
        const errorMessage = error.response?.data?.message || "Failed to update student marks";
        dispatch(getError(errorMessage));
        return { success: false, error: errorMessage };
    }
};

export const removeStuff = (id, address) => async (dispatch) => {
    dispatch(getRequest());
    try {
        const result = await axios.put(`${BASE_URL}/${address}/${id}`);
        if (result.data?.message) {
            dispatch(getFailed(result.data.message));
        } else {
            dispatch(stuffDone(result.data));
        }
    } catch (error) {
        const errorMessage = error.response?.data?.message || error.message || "Failed to update student information";
        dispatch(getError(errorMessage));
    }
};
